import React from 'react';
import { shouldShowField } from '../../../../components/InputField/helper';
import { WrapperField } from '../../../../components/InputField/WrapperField';
import { shouldIncludeConversionPlanActivityField } from './helperV2';
import "../../../../components/SuperResponsiveTableStyle.css";

const normalizeExpectedActivityTableField = (jsonField = {}) => {
    if (!jsonField?.field) {
        return jsonField;
    }

    const isNumericActivityField = (
        jsonField?.type === "number"
        || jsonField?.valueType === "integer"
        || jsonField?.uiType === "numberField"
        || jsonField?.uiType === "amountField"
        || jsonField?.uiType === "currencyField"
        || jsonField?.uiRegex === "^[0-9]+$"
    );

    if (!isNumericActivityField) {
        return {
            ...jsonField,
            noLabel: true,
        };
    }

    return {
        ...jsonField,
        uiType: "numberField",
        noLabel: true,
        placeholder: "",
        showInputGroupText: Boolean(jsonField?.inputGroupText),
        inputGroupText: jsonField?.inputGroupText,
    };
};

const ExpectedActivityTableV2 = ({
    fieldOrder = [],
    fieldMap = {},
    data,
    asLabel,
    handleChange,
    hasError,
    onFieldError,
    dataTestId = 'business-v2-expected-activity-table',
    valueHeaderLabel = 'Expected Activity',
}) => {
    const orderedFields = Array.isArray(fieldOrder) ? fieldOrder : [];
    const visibleOrderedFields = orderedFields.filter((field) => {
        const jsonField = fieldMap?.[field];
        return Boolean(jsonField?.uiType)
            && shouldIncludeConversionPlanActivityField(field, data)
            && shouldShowField(data, jsonField?.showIf);
    });

    if (!visibleOrderedFields.length) {
        return null;
    }

    return (
        <div className="transaction-table transaction-table--expected p-0 mb-3 mt-4" data-testid={dataTestId}>
            <table className="transaction-value-table transaction-value-table--expected">
                <thead>
                    <tr>
                        <th className="header-cell">Question</th>
                        <th className="header-cell text-end value-cell">{valueHeaderLabel}</th>
                    </tr>
                </thead>
                <tbody>
                    {visibleOrderedFields.map((field) => {
                        const jsonField = fieldMap?.[field];
                        const tableField = normalizeExpectedActivityTableField(jsonField);

                        return (
                            <tr key={field}>
                                <td className="transaction-question-cell">{jsonField?.label}</td>
                                <td className="p-0 m-0 transaction-input text-end value-cell transaction-value-cell">
                                    <span className="transaction-value-table__mobile-label">{valueHeaderLabel}</span>
                                    <WrapperField
                                        disabled={asLabel}
                                        jsonField={tableField}
                                        dataObj={data}
                                        onChange={handleChange}
                                        showError={hasError}
                                        onError={(errorMsg) => onFieldError?.(field, errorMsg)}
                                        customProp="plain"
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default ExpectedActivityTableV2;
